export default __webpack_public_path__ + "static/media/liberum-3.b782d72e.png";